import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DOMPurify from "dompurify";
import BreadCumb from "../component/BreadCumb";
import {Helmet} from "react-helmet-async";

const Faq = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [faqCategories, setFaqCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const cacheExpiryTime = 30 * 60 * 1000; // 30 minutes

    useEffect(() => {
        // Check if cached FAQs are available
        const cachedData = JSON.parse(localStorage.getItem('faqCategories'));

        if (cachedData) {
            const { data, timestamp } = cachedData;
            const currentTime = Date.now();

            if (currentTime - timestamp < cacheExpiryTime) {
                // If cached data is valid, use it
                setFaqCategories(data);
                setLoading(false);
            } else {
                // If the cache has expired, remove it and fetch new data
                localStorage.removeItem('faqCategories');
                fetchFaqs();
            }
        } else {
            // If no cached data, fetch the FAQs
            fetchFaqs();
        }
    }, []);

    const fetchFaqs = async () => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_FAQ;

        try {
            const response = await axios.get(`${apiBaseUrl}${Url}`);
            const fetchedData = response.data;

            // Cache the fetched data along with the current timestamp
            const dataWithTimestamp = {
                data: fetchedData,
                timestamp: Date.now(),
            };
            localStorage.setItem('faqCategories', JSON.stringify(dataWithTimestamp));

            setFaqCategories(fetchedData);
            setLoading(false);
        } catch (error) {
            console.error('Failed to fetch Faqs:', error);
            setLoading(false);
        }
    };

    if (loading) {
        return <div>Loading...</div>; // Show loading message until the data is loaded
    }

    return (
        <>
            <Helmet>
                <title>Tarif Overseas Ltd. | Frequently Ask Question</title>
                <meta name="description" content="Tarif Overseas Ltd. is a trusted overseas recruitment agency in Bangladesh providing professional manpower recruitment services."/>
                <link rel="canonical" href={`https://tarifoverseasltd.com/contact-us`}/>
            </Helmet>
            <main className="main">
            <BreadCumb image="faq.webp" />
            <div className="faq-area pt-100 pb-80">
                <div className="container">
                    <div className="row">
                        {faqCategories?.map((category, catIndex) => (
                            <div className="col-lg-6 my-2" key={catIndex}>
                                <div className="card">
                                    <div className="card-header text-center" style={{ backgroundColor: '#1C4ABE' }}>
                                        <h5 className={'fw-bold text-white'}>{category?.name_bangla}</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="accordion wow fadeInRight" data-wow-delay=".25s" id={`accordionExample${catIndex}`}>
                                            {category.faqs?.map((faq, index) => (
                                                <div className="accordion-item my-2" key={index}>
                                                    <h5 className="accordion-header" id={`heading-${catIndex}-${index}`}>
                                                        <button className="accordion-button text-dark" style={{ fontSize: '15px' }} type="button" data-bs-toggle="collapse"
                                                                data-bs-target={`#collapse-${catIndex}-${index}`} aria-expanded={index === 0}
                                                                aria-controls={`collapse-${catIndex}-${index}`}>
                                                            {faq.question}
                                                        </button>
                                                    </h5>
                                                    <div id={`collapse-${catIndex}-${index}`} className={`accordion-collapse collapse`}
                                                         aria-labelledby={`heading-${catIndex}-${index}`} data-bs-parent={`#accordionExample${catIndex}`}>
                                                        <div className="accordion-body">
                                                            <div className="site-heading text-dark mb-3" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(faq.answer) }}>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </main>
        </>
    );
};

export default Faq;
